// import config from '@/config'
import popularParlays from './popularParlays'
import recommended from './recommended'

export default {
  popularParlays,
  recommended
}



// WEBPACK FOOTER //
// ./src/library/personalization/index.js